import React, { Component, Fragment } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import QRCode from 'qrcode'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { v4 as uuidv4 } from 'uuid';
import ReactTooltip from 'react-tooltip'


import http from 'axios'

// TODO: run npm link inside lbp-viw-sdk/src
//import LoqrVideo from '/usr/local/lib/node_modules/lbp-viw-sdk'
//import LoqrRTC, { Camera } from '../../dist'
import ConnectionInfo from './ConnectionInfo';
//import LoqrRTC from 'lbp-viw-sdk-browser'
import LoqrRTC, { Camera, io } from 'lbp-viw-sdk'

class App extends Component {
    constructor() {
        const searchResolution = {};
        window.location.search.replace('?', '').split('&').forEach(step => {
            const [key, value] = step.split("=")
            searchResolution[key] = value;
        })

        console.log('searchResolution: ', searchResolution)
        super()
        this.state = {
            error: '',
            message: '',
            roomId: '',
            joinRoomId: '',
            peerToken: 'DEFAULT',
            videoInputDevices: [],
            remoteVideoInputDevices: [],
            audioInputDevice: [],
            audioOutputDevice: [],
            roomSet: false,
            type: 'owner',
            audio: true,
            video: true,
            wwss: process.env.REACT_APP_WWSS,
            wwssSet: false,
            constraints_audio: true,
            constraints_video: true,
            signalingStarted: false,
            calling: false,
            recording: false,
            messages: [],
            minimalInstallColOffset: 0,
            connectionStatus: [],
            selfCall: false,
            stream: undefined,
            customWidth: searchResolution.width,
            customHeight: searchResolution.height
        }
    }

    onLocalStreamReady = (stream) => {
        /* this.localVideo.srcObject = stream
        this.localVideo.onloadedmetadata = function () {
            console.log('width is', this.videoWidth);
            console.log('height is', this.videoHeight);
        } */
    }
    onRemoteStreamReady = (stream) => {
        /*  this.remoteVideo.srcObject = stream */
    }

    showQR(type) {

        var canvas_remote = document.getElementById(`canvas_token`)
        /* var canvas_local = document.getElementById('canvas_local')
        var canvas_self = document.getElementById('canvas_self')
*/
        this.setState({ showType: type })
        console.log(type, ' < --his.state[`${type}Token`] ', this.state[`${type}Token`])
        QRCode.toCanvas(canvas_remote, this.state[`${type}Token`], function (error) {
            if (error) console.error('canvas_remote>>>>>>>>>>>>>>> s', error)
            console.log('success!');
        })
        /*  QRCode.toCanvas(canvas_local, response.data.ownerToken, function (error) {
             if (error) console.error(error)
             console.log('success!');
         })
         QRCode.toCanvas(canvas_self, self.data.selfToken, function (error) {
             if (error) console.error(error)
             console.log('success!');
         }) */
    }

    getAuthToken = async () => {
        try {
            console.log('-- getAuthToken --')
            const options = {
                method: 'POST',
                // url: 'https://wwss-00.cluster.loqr.io/v1/auth',
                url: process.env.REACT_APP_WWSS_URL,
                headers: {},
                data: {
                    identityId: uuidv4(),
                    callbackUrl: 'https://hook.lqr.pt/892be464-72bd-4ef5-a47a-74316bf60cbc'
                }
            };
            const response = await http.request(options);
            const self = await http.request({
                method: 'POST',
                // url: 'https://wwss-00.cluster.loqr.io/v1/auth',
                url: process.env.REACT_APP_WWSS_URL,
                headers: {},
                data: {
                    type: 'self',
                    identityId: uuidv4(),
                    callbackUrl: 'https://hook.lqr.pt/892be464-72bd-4ef5-a47a-74316bf60cbc'
                }
            });

            console.log('RESPONSE: ', response)
            this.setState({
                ownerToken: response.data.ownerToken,
                peerToken: response.data.peerToken,
                selfToken: self.data.selfToken,
                roomSet: true,
                roomId: response.data.ownerToken,
                callId: response.data.callId
            })
        } catch (err) {

        }
    }

    componentDidMount() {
        // Send page stream to sdk!
        const USE_CUSTOM_STREAM = false;
        if (USE_CUSTOM_STREAM) {
            (async () => {
                const s = await this.loadLoaclStream()
                this.handleSetSignaling(s)
            })()
        } else {
            this.handleSetSignaling()
        }
    }

    scrollMsgBottom() {
        setTimeout(() => {
            var objDiv = document.getElementById("chat-msg-div");
            console.log('objDiv.scrollHeight: ', objDiv.scrollHeight)
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 500)
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (this.state.message.length > 0) {
                this.handleSendMessage()
            }
            console.log('enter press here! ')
        }
    }

    handleSetSignaling = (stream = undefined) => {
        const signalingWss = this.state.wwss// 'ws://192.168.50.149:8280'// 

        let peerConstraints = {}
        if (window.location.href.indexOf('data') > -1) {
            peerConstraints = {
                wwss: signalingWss,
                video: false,
                audio: false
            }
            console.log('DATA ONLY')
        } else {

            if (!stream) {
                peerConstraints = {
                    wwss: signalingWss,
                    video: this.state.constraints_video,
                    audio: false,//this.state.constraints_audio,
                    //  facingMode: 'user',//'user'||'environment'
                    orientation: 'portrait',// 'portrait' || 'landscape'
                    //aspectRatio: '0.45',
                }
            } else {
                peerConstraints = {
                    wwss: signalingWss,
                    stream
                }
                alert('stream fw!')
            }
            console.log('VIDEO AUDIO')
        }

        let options = {};
        if (this.state.customWidth && this.state.customHeight) {
            options = {
                resolution: {
                    width: this.state.customWidth,
                    height: this.state.customHeight
                }
            }
        }

        const loqrRTC = new LoqrRTC(peerConstraints, options)

        //loqrWebRTC.

        loqrRTC.on('message', (message) => {
            console.log('APP: Message Received: ', message)
            this.setState({ messages: [...this.state.messages, { owner: 'other', text: JSON.stringify(message) }] })
        })
        loqrRTC.on('connected', () => {
            console.log('APP: Peers are connected')
            this.setState({
                calling: false
            })
        })

        loqrRTC.on('error', (err) => {
            this.setState({ error: err.message ? err.message : 'Something unexpected just happen!' })
            setTimeout(() => {
                this.setState({ error: '' })
            }, 8000)
            this.handleReport()
            console.error('Error on App: ', err.message)
        })
        loqrRTC.on('disconnect', () => {
            console.error('** Socket Disconnected! **')
            this.handleHangup()
        })


        loqrRTC.on('localPeerConnected', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'localPeerConnected'] })
        })

        //--------------
        loqrRTC.on('localStreamReady', (stream) => {
            console.log('GOT localStreamReady');

            if ("srcObject" in this.localVideo) {
                this.localVideo.srcObject = stream;
            } else {
                // Avoid using this in new browsers, as it is going away.
                this.localVideo.src = window.URL.createObjectURL(stream);
            }
            // const height = stream.getVideoTracks()[0].getSettings().height;
            // const width = stream.getVideoTracks()[0].getSettings().width;

            this.localVideo.onloadedmetadata = function () {
                //  this.localVideo.play();
                console.log('width is', this.videoWidth);
                console.log('height is', this.videoHeight);
            }

        })

        loqrRTC.on('localPeerRecording', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'localPeerRecording'] })
        })

        loqrRTC.on('localPeerDisconnected', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'localPeerDisconnected'] })
        })

        loqrRTC.on('remotePeerConnected', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'remotePeerConnected'] })
        })

        loqrRTC.on('remoteStreamReady', (stream) => {
            this.remoteVideo.srcObject = stream
        })

        loqrRTC.on('remotePeerDisconnected', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'remotePeerDisconnected'] })
            loqrRTC.hangup()
        })

        loqrRTC.on('remotePeerHangup', () => {
            alert('Remote Peer Disconnect')
        })

        loqrRTC.on('localPeerStartConnecting', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'localPeerStartConnecting'] })
        })
        loqrRTC.on('remotePeerStartConnecting', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'remotePeerStartConnecting'] })
        })

        loqrRTC.on('recordingStarted', (data) => {
            console.log('RECORD STARTED!!!!!')
            this.setState({ recordingStarted: true })
        })
        loqrRTC.on('recordingProgress', (data) => {
            console.log('Progress>> ', data)
        })

        loqrRTC.on('selectVideoInputDevice', (videoInputDevices) => {
            this.setState({ videoInputDevices })
        })

        loqrRTC.on('remoteVideoInputDevices', (remoteVideoInputDevices) => {
            console.log('remoteVideoInputDevices=>>>>>>>>>>> ', remoteVideoInputDevices)
            this.setState({ remoteVideoInputDevices })
        })

        loqrRTC.on('selectAudioInputDevice', (audioInputDevice) => {
            this.setState({ audioInputDevice })
        })
        loqrRTC.on('selectAudioOutputDevice', (audioOutputDevice) => {
            this.setState({ audioOutputDevice })
        })
        loqrRTC.on('localPeerReady', () => {
            this.setState({ connectionStatus: [...this.state.connectionStatus, 'localPeerReady'] })
        })

        loqrRTC.on('selectedVideoInputDevice', deviceId => {
            this.setState({ videoInputDeviceId: deviceId });
        })

        loqrRTC.on('selectedAudioInputDevice', deviceId => {
            this.setState({ audioInputDeviceId: deviceId });
        })
        loqrRTC.on('selectedAudioInputDevice', deviceId => {
            this.setState({ audioOutputDeviceId: deviceId });
        })

        this.setState({ loqrRTC, wwssSet: true })
    }

    handleCall = () => {

        console.log('Room ', this.state.roomId);
        console.log('Type ', this.state.type);

        //  this.state.loqrRTC.call(this.state.joinRoomId === '' ? this.state.ownerToken : this.state.joinRoomId)

        this.state.loqrRTC.connect(this.state.joinRoomId === '' ? this.state.ownerToken : this.state.joinRoomId);
        //this.state.loqrRTC.connect(this.state.ownerToken, this.state.peerToken);
        this.setState({ signalingStarted: true, calling: true, selfCall: false })
    }

    handleSelfCall = () => {

        console.log('Room ', this.state.roomId);
        console.log('Type ', this.state.type);
        const token = (this.state.selfToken)
        this.state.loqrRTC.connect(token);
        this.setState({ signalingStarted: true, calling: true, selfCall: true })
    }

    handleRecord = () => {
        this.state.loqrRTC.record()
        this.setState({
            recording: true
        })
    }

    handleSendMessage = () => {
        this.state.loqrRTC.send({ message: this.state.message })
        this.setState({ message: '', messages: [...this.state.messages, { owner: 'me', text: this.state.message }] })
        this.scrollMsgBottom()
    }
    handleSendAction = () => {
        const action = { action: this.state.message };
        this.state.loqrRTC.send(action)
        this.setState({ message: '', messages: [...this.state.messages, { owner: 'me', text: JSON.stringify(action) }] })
        this.scrollMsgBottom()
    }

    handleLogMessage = async () => {
        this.state.loqrRTC.send({ event: 'log', data: this.state.message })
        this.setState({ message: '', messages: [...this.state.messages, { owner: 'me', text: this.state.message }] })
        this.scrollMsgBottom()
        const cameras = await this.state.loqrRTC.getCameras();
        console.log(cameras)
    }

    handleAudio = () => {
        this.state.loqrRTC.audio(!this.state.audio)
        this.setState({ audio: !this.state.audio })
    }
    handleVideo = () => {
        this.state.loqrRTC.video(!this.state.video)
        this.setState({ video: !this.state.video })
    }

    handleHangup = () => {
        this.state.loqrRTC.hangup({ reason: 'reasons!' })
        this.setState({ signalingStarted: false, calling: false, recording: false })
    }

    handleSwitch = () => {
        //Please, please ask @JD
        this.state.loqrRTC.switchCamera()
    }

    handleReport = () => {
        this.state.loqrRTC.report()
    }

    handleNet = () => { }

    handleMessageChange = (evt) => {
        this.setState({ message: evt.target.value })
    }
    handleRoomIdChange = (evt) => {
        this.setState({ joinRoomId: evt.target.value })
    }

    handleWWSS = (evt) => {
        this.setState({ wwss: evt.target.value })
    }

    handleCheckVideo = (evt) => {
        this.setState({ constraints_video: (evt.checked ? true : false) })
    }

    copyClipboard = () => {
        this.setState({ copied: true })
        console.log('Copied!!')
    }

    handleVideoInputDeviceChange = async (evt) => {
        this.setState({ deviceId: evt.target.value });
    }

    handleRemoteVideoInputDeviceChange = async (evt) => {
        this.setState({ remoteDeviceId: evt.target.value });
    }

    handleAudioInputDeviceChange = async (evt) => {
        this.setState({ audioInputDeviceId: evt.target.value });
    }
    handleAudioOutputDeviceChange = async (evt) => {
        /*   console.log('handleAudioOutputDeviceChange> ', evt.target.value)
          document.getElementById("remoteVideo").setSinkId(evt.target.value); */
        this.setState({ audioOutputDeviceId: evt.target.value });
    }

    previewDevice = async (deviceId) => {
        try {
            const stream = await this.state.loqrRTC.previewVideoDevice(deviceId)
            console.log('previewDevice>> ', stream)
            if ("srcObject" in this.localVideo) {
                this.localVideo.srcObject = stream;
            } else {
                // Avoid using this in new browsers, as it is going away.
                this.localVideo.src = window.URL.createObjectURL(stream);
            }
            this.localVideo.onloadedmetadata = function () {
                //  this.localVideo.play();
                console.log('width is', this.videoWidth);
                console.log('height is', this.videoHeight);
            }
        } catch (err) {
            alert('DAM SON!!!');
            console.log(err);
        }
    }

    loadLoaclStream = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true
        });
        return stream;
    }

    render() {
        return (
            <div className="App">
                <div className="row header">
                    <div className="col-md-2">
                        <img src="./loqr-logo-white.png" width="130" alt="logo" />
                    </div>
                </div>
                <button onClick={this.handleReport}>REPORT</button>
                <p><b>Version:</b> {LoqrRTC.version}</p>
                <div className="row page-content" >
                    {this.state.error.length > 0 &&
                        <div className="col-sm-12">
                            <div className="alert alert-danger">
                                <strong>{this.state.error}</strong>
                            </div>
                        </div>
                    }
                    {/*
                    <button onClick={this.handleAudio}>Audio (On/Off)</button>
                    <button onClick={this.handleVideo}>Video (On/Off)</button>
                    */}
                    {this.state.recordingStarted &&
                        <h1>Recording...</h1>
                    }
                    <div className={`col-lg-${2 + this.state.minimalInstallColOffset} col-md-${1 + this.state.minimalInstallColOffset}  col-sm-${this.state.minimalInstallColOffset}`}></div>
                    <div className="col-lg-4 col-md-5 col-sm-6" hidden={this.state.roomSet}>
                        {/*  <div className="col-md-1"> <button style={btnCreateRoom} onClick={this.getAuthToken}>Auth</button></div> */}
                        <button id="createRoom" className="btnCreateRoom" onClick={this.getAuthToken}>Create New Room</button>
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-6" hidden={this.state.roomSet}>
                        {/* <input className="chat-input" value={this.state.joinRoomId} onChange={this.handleRoomIdChange} type="text" />
                        <button disabled={this.state.joinRoomId.length !== 4} className="btn-sm btn-success" onClick={() => this.setState({ roomId: this.state.joinRoomId, roomSet: true, type: 'peer', })} >Join Room</button> */}
                        <input id="setToken" className="chat-input" value={this.state.joinRoomId} onChange={this.handleRoomIdChange} type="text" />
                        <button id="btnToken" className="btn-sm btn-success" onClick={() => this.setState({ roomId: this.state.joinRoomId, roomSet: true, type: 'peer', })} >Set Token</button>
                    </div>
                </div>
                <div className="text-center col-sm-12">
                    <div className="text-center col-sm-6" hidden={this.state.videoInputDevices.length === 0}>
                        <Fragment>
                            <p>videoInputDevices</p>
                            <select value={this.state.deviceId} onChange={this.handleVideoInputDeviceChange}>
                                {this.state.videoInputDevices.map((device, index) => {
                                    return (
                                        <option key={'device_' + index} value={device.deviceId}>{device.label}</option>
                                    )
                                })}
                            </select>
                            <button onClick={() => { this.state.loqrRTC.setVideoInputDeviceId(this.state.deviceId) }}>Set Video Input</button>
                        </Fragment>

                    </div>

                    <div className="text-center col-sm-6" hidden={this.state.audioInputDevice.length === 0}>
                        <Fragment>
                            <p>Audio Input</p>
                            <select value={this.state.audioInputDeviceId} onChange={this.handleAudioInputDeviceChange}>
                                {this.state.audioInputDevice.map((device, index) => {
                                    return (
                                        <option key={'device_' + index} value={device.deviceId}>{device.label}</option>
                                    )
                                })}
                            </select>
                            <button onClick={() => { this.state.loqrRTC.setAudioInputDeviceId(this.state.audioInputDeviceId) }}>Set Audio Input</button>
                        </Fragment>
                    </div>
                    <div className="text-center col-sm-6" hidden={this.state.audioOutputDevice.length === 0}>
                        <Fragment>
                            <p>Audio Output</p>
                            <select value={this.state.audioOutputDeviceId} onChange={this.handleAudioOutputDeviceChange}>
                                {this.state.audioOutputDevice.map((device, index) => {
                                    return (
                                        <option key={'device_' + index} value={device.deviceId}>{device.label}</option>
                                    )
                                })}
                            </select>
                            <button onClick={() => {
                                // @experimental
                                this.state.loqrRTC.setAudioOutputDeviceId(this.state.audioOutputDeviceId, "localVideo")
                                this.state.loqrRTC.setAudioOutputDeviceId(this.state.audioOutputDeviceId, "remoteVideo")
                            }}>Set Audio Output</button>
                        </Fragment>
                    </div>
                </div>

                <div className="text-center col-sm-12" hidden={!this.state.customWidth || !this.state.customHeight}>
                    <p>Trying Enforced resolution: {this.state.customWidth}x{this.state.customHeight}</p>
                </div>
                <div className="text-center col-sm-12" hidden={!this.state.roomSet}>
                    <input id="peerToken" value={this.state.peerToken} type="hidden" />
                    <Fragment>
                        <CopyToClipboard text={this.state.peerToken}
                            onCopy={this.copyClipboard}>
                            <span style={{ cursor: 'copy', color: this.state.copied ? 'green' : 'black' }}><b id="copyToken">Copy Peer Token</b></span>
                        </CopyToClipboard>
                        <h4 style={{ color: "darkgray" }}>Call <b>{this.state.callId}</b></h4>
                        <h4 style={{ color: "darkgray" }}>You are <b>{this.state.type === 'owner' ? 'Operator' : 'Client'}</b>{ } in room <b>{this.state.roomId.slice(0, 8) + '...'}</b></h4><a href="" style={{ cursor: 'pointer' }} onClick={() => this.setState({ roomSet: false })}>(Cancel)</a>
                    </Fragment>
                </div>
                {
                    this.state.roomSet &&
                    <div className="row page-content" >
                        {/* <div className={`col-lg-${2 + this.state.minimalInstallColOffset} col-md-${1 + this.state.minimalInstallColOffset}  col-sm-${this.state.minimalInstallColOffset}`}></div> */}
                        <div className="col-lg-4 col-md-5  col-sm-6">
                            {this.state.recording &&
                                <span className="record-blink blink_me"><i className="fa fa-circle"></i></span>
                            }
                            <video id="remoteVideo" className="remoteVideo" ref={node => this.remoteVideo = node} playsInline autoPlay></video>
                            <video id="localVideo" className="localVideo" muted="muted" src={this.localStream} ref={node => this.localVideo = node} playsInline autoPlay></video>
                            {/*
                        Actions BTNS
                            */}
                            <div className="optionsBar">
                                <div style={{ zIndex: "8", position: "inherit" }}>
                                    {!this.state.signalingStarted &&
                                        <Fragment>
                                            <button id="startCall" onClick={this.handleSelfCall}><i className="fa fa-user"></i></button>
                                            <button id="startCall" onClick={this.handleCall}><i className="fa fa-phone"></i></button>
                                        </Fragment>
                                    }
                                    {this.state.signalingStarted &&
                                        <Fragment>
                                            <button id="hangupButton" onClick={this.handleHangup}><i className="fa fa-phone"></i></button>
                                            <button id="switchCamera" onClick={this.handleSwitch}><i className="fa fa-refresh"></i></button>
                                            {!this.state.recording &&
                                                <button id="recordButton" onClick={this.handleRecord}><i className="fa fa-circle"></i></button>
                                            }
                                        </Fragment>
                                    }
                                </div>
                                {this.state.calling &&

                                    <div className="loading-dots">
                                        <span className="loader__dot">.</span><span className="loader__dot">.</span><span className="loader__dot">.</span>
                                    </div>
                                }
                            </div>
                            <div className="text-center col-sm-6" hidden={this.state.remoteVideoInputDevices.length === 0}>
                                <Fragment>
                                    <p>Remote videoInputDevices</p>
                                    <select value={this.state.remoteDeviceId} onChange={this.handleRemoteVideoInputDeviceChange}>
                                        {this.state.remoteVideoInputDevices.map((device, index) => {
                                            return (
                                                <option key={'device_' + index} value={device.deviceId}>{device.label}</option>
                                            )
                                        })}
                                    </select>
                                    <button onClick={() => { this.state.loqrRTC.setRemoteVideoInputDeviceId(this.state.remoteDeviceId) }}>Set Remote Video Input</button>
                                </Fragment>

                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4  col-sm-4" >
                            <div className="chat">
                                <div id="chat-msg-div" className="chat-msg-div">
                                    {this.state.messages.map((m, i) =>
                                        <p className={'chat-text ' + 'msg-' + m.owner} key={i}>{m.text}</p>
                                    )}
                                </div>
                                <div className="chatInputBlock">
                                    <p><button className="btn-sm btn-info" onClick={this.handleLogMessage} >Log</button><button className="btn-sm btn-danger" onClick={this.handleSendAction} >ACTION</button></p>
                                    <input className="chat-input" id="dataChannelSend" value={this.state.message} onChange={this.handleMessageChange} onKeyPress={this.handleKeyPress} type="text" />
                                    <button className="btn-sm btn-success chat-btn" onClick={this.handleSendMessage} >Send</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3  col-sm-4">
                            <ConnectionInfo></ConnectionInfo>
                            <hr />
                            <div className="row" >
                                <div className="col-sm-12">
                                    <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                        <label className={`btn btn-info ${this.state.showType === 'owner' ? 'active' : ''}`} onClick={() => this.showQR('owner')}>
                                            <input type="radio" name="options" id="option1" autoComplete="off" readOnly checked={this.state.showType === 'owner' ? true : false} /> Owner
                                        </label>
                                        <label className={`btn btn-info ${this.state.showType === 'peer' ? 'active' : ''}`} onClick={() => this.showQR('peer')}>
                                            <input type="radio" name="options" id="option2" autoComplete="off" readOnly checked={this.state.showType === 'peer' ? true : false} /> Peer
                                        </label>
                                        <label className={`btn btn-info ${this.state.showType === 'self' ? 'active' : ''}`} onClick={() => this.showQR('self')}>
                                            <input type="radio" name="options" id="option3" autoComplete="off" readOnly checked={this.state.showType === 'self' ? true : false} /> Self
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-12 m-2 p-2">
                                    <canvas style={{
                                        width: '400px',
                                        height: '400px',
                                        paddingLeft: '50px',
                                        paddingRight: '50px'
                                    }} id="canvas_token"></canvas>
                                </div>
                            </div>
                            <hr />
                            <p><b>Call status</b></p>
                            {this.state.connectionStatus.map((s, index) => (<p key={'connectionStatus-' + index}>{index} - {s}</p>))}
                        </div>

                    </div>
                }
            </div >
        );
    }
}

export default App;
